import React from "react";

const TextAreaFormSkeleton = () => {
  return (
    <div className="px-4 py-6 sm:p-8">
      <div className="animate-pulse">
        <div className="space-y-6">
          <div>
            <div className="h-4 bg-cream-300 rounded w-32 mb-2"></div>
            <div className="h-24 bg-cream-300 rounded w-full"></div>
            <div className="flex justify-end mt-2">
              <div className="h-3 bg-cream-300 rounded w-16"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextAreaFormSkeleton;
